import { useState } from "react";
import { BASE_URL } from "../utilities/BASE_URL";
import { postWithToken } from "../utilities/fetchWithToken";
import "./AdminBlast.css";

// Admin controls -> "Schedule tournament": name + start time + buy-in (+ optional late-reg
// minutes), posted to POST /admin/tournaments. The buy-in is the starting stack and drives the
// Sit-and-Go blind schedule (2% base, 5-minute levels). The sweeper launches it at the start time
// if >= 2 players registered; otherwise it cancels and refunds. Admin-gated server-side.
const ScheduleTournamentModal = ({ onClose }) => {
    const [name, setName] = useState("");
    const [startsAt, setStartsAt] = useState("");
    const [buyIn, setBuyIn] = useState(100);
    const [lateRegMinutes, setLateRegMinutes] = useState(15);
    const [status, setStatus] = useState("idle"); // idle | pending | done | failed
    const [error, setError] = useState("");

    const canSubmit =
        name.trim().length > 0 && startsAt && Number(buyIn) > 0 && status !== "pending";

    const submit = async (e) => {
        e.preventDefault();
        if (!canSubmit) return;
        setStatus("pending");
        setError("");
        try {
            const scheduledStartAt = new Date(startsAt).getTime();
            const res = await postWithToken(`${BASE_URL}/admin/tournaments`, {
                name: name.trim(),
                scheduledStartAt,
                buyIn: Number(buyIn),
                lateRegMinutes: Number(lateRegMinutes),
            });
            if (!res.ok) {
                const text = await res.text();
                throw new Error(text || "Failed to schedule tournament");
            }
            setStatus("done");
            setTimeout(onClose, 900);
        } catch (err) {
            setStatus("failed");
            setError(err.message);
        }
    };

    return (
        <div className="admin-blast-overlay" onClick={onClose}>
            <div
                className="admin-blast-dialog"
                onClick={(e) => e.stopPropagation()}
                role="dialog"
                aria-modal="true"
            >
                <h3 className="admin-blast-title">Schedule tournament</h3>
                <form className="admin-blast-form" onSubmit={submit}>
                    <label className="admin-blast-label" htmlFor="tourn-name">Name</label>
                    <input
                        id="tourn-name"
                        className="admin-blast-input"
                        type="text"
                        maxLength={120}
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        autoFocus
                    />
                    <label className="admin-blast-label" htmlFor="tourn-start">Starts at</label>
                    <input
                        id="tourn-start"
                        className="admin-blast-input"
                        type="datetime-local"
                        value={startsAt}
                        onChange={(e) => setStartsAt(e.target.value)}
                    />
                    <label className="admin-blast-label" htmlFor="tourn-buyin">Buy-in (= starting stack)</label>
                    <input
                        id="tourn-buyin"
                        className="admin-blast-input"
                        type="number"
                        min={1}
                        value={buyIn}
                        onChange={(e) => setBuyIn(e.target.value)}
                    />
                    <label className="admin-blast-label" htmlFor="tourn-latereg">Late registration (minutes)</label>
                    <input
                        id="tourn-latereg"
                        className="admin-blast-input"
                        type="number"
                        min={0}
                        value={lateRegMinutes}
                        onChange={(e) => setLateRegMinutes(e.target.value)}
                    />
                    {status === "failed" && <div className="admin-blast-error">{error}</div>}
                    {status === "done" && <div className="admin-blast-sent">Scheduled!</div>}
                    <div className="admin-blast-buttons">
                        <button
                            type="submit"
                            className="admin-blast-btn admin-blast-btn-send"
                            disabled={!canSubmit}
                        >
                            {status === "pending" ? "Scheduling…" : "Schedule"}
                        </button>
                        <button
                            type="button"
                            className="admin-blast-btn admin-blast-btn-cancel"
                            onClick={onClose}
                        >
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ScheduleTournamentModal;
